import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";


const RefundPolicy = () => {

  const location = useLocation();
  const [categorydata, setcategorydata] = useState([]);

  useEffect(() => {
    const shopcategory = async () => {
      try {
        const response = await axios.get(site_url + '/get_site_policy');
        if (response.data.status == 'success') {
          setcategorydata(response.data.data);
          console.log(response.data.data);
        }
      } catch (error) {
      }
    }

    shopcategory();

  }, [])

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Optionally, clear all inline styles (use with caution)
    // document.body.removeAttribute("style");
  }, [location]);


  return (
    <div className="max-w-3xl mx-auto p-6 p-2">
      <div style={{
        marginBottom: '20px',
        padding: '15px',
        background: '#f8f9fa',
        borderRadius: '8px',
        borderLeft: '4px solid #667eea',
        fontSize: '14px',
        lineHeight: '1.6',
        fontWeight: '500',
        color: '#333'
      }}>
        "APM Smart HUB" is a unit of APM ECOM MART private limited, established in the year 2023 March.
      </div>
      <div dangerouslySetInnerHTML={{ __html: categorydata?.about }} />
    </div>
  );
};

export default RefundPolicy;
